import sanitize from 'sanitize-html'

export const stripHTMLFromText = (text?: string): string =>
  !text ? '' : text.replace(/<(?:.|\n)*?>/gm, '')

// Return a "safe" subset of HTML
export const sanitizeHtml = (html: string): string => {
  const colorMatchers = [
    /^#(0x)?[0-9a-f]+$/i,
    /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
  ]

  return sanitize(html, {
    allowedTags: false,
    allowedAttributes: {
      ...sanitize.defaults.allowedAttributes,
      '*': ['style'],
      iframe: ['src'],
    },
    allowedStyles: {
      '*': { 'background-color': colorMatchers, color: colorMatchers },
    },
  })
}
